import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

const domainTarget = {
  kind: "configuration" as const,
  field: "domain",
} as const;

export const wazuh = defineConnector({
  identifier: "wazuh",
  name: "Wazuh",
  tagLine: "Open source security monitoring",
  logo,
  protocol: "http",
  tags: ["security", "observability"],
  defaultUrlPattern: ({ domain }) =>
    domain ? `https://${domain.replace(/\./g, "\\.")}/.*` : "https://.*/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.domain}/security/user/authenticate`,
        basicAuth: {
          username: app.secret.username,
          password: app.secret.password,
        },
      },
      extract: {
        from: "jsonPath",
        paths: ["data.token"],
        fallbackToRawBody: true,
      },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Enter your Wazuh instance URL",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "wazuh.example.com:55000",
          target: domainTarget,
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter your Wazuh API username and password. The default user is `wazuh-wui`.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/manager/status`,
  },
});
